// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2HtEq","loginform":"styles_loginform__62FB5","item":"styles_item__H21cC"};